import React, { useState, Suspense, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { urls } from "./utils";
import { Header, SVGAssets, LoadingBar } from "./components/";
import { Visualization3D } from "./components/Visualization3D";
import Platform from "./pages/Platform";
import Explore from "./pages/Explore";
import CorporateStructure from "./pages/CorporateStructure";
import Panorama from "./pages/Panorama";
import { GoToSections } from "./pages/Navigation";
import Intro from "./pages/Intro";
import Soundmachine from "./pages/Soundmachine";

const Context3D = React.lazy(() => import("./components/Context3D"));

function App() {
  const [webGLContextInitialized, setWebGLContextInitialized] = useState(false);
  // const actions = useStore(useCallback((state) => state.actions, []));
  // const showHeader = useStore(useCallback((state) => state.app.showHeader, []));

  const location = useLocation();
  const withVisualization = [urls.explore.path, urls.platform.path].includes(
    location.pathname
  );

  useEffect(() => {
    if (withVisualization && !webGLContextInitialized) {
      console.log("WebGL context initialized");
      setWebGLContextInitialized(true);
    }
  }, [withVisualization, webGLContextInitialized]);

  return (
    <>
      <div className="clearfix app__container block-font">
        <Switch>
          <Route
            exact
            path={[
              urls.root.path,
              urls.archive.path,
              urls.corporate.path,
              urls.explore.path,
              urls.platform.path,
              urls.fleming.path,
              urls.soundmachine.path,
            ]}
            render={() => <Header />}
          />
        </Switch>
        <Switch>
          <Route exact path={[urls.root.path]}>
            <Intro />
          </Route>
          <Route exact path={[urls.archive.path]}>
            <Panorama />
            <GoToSections
              next={{
                text: urls.explore.text,
                url: urls.explore.path,
              }}
            />
          </Route>
          <Route exact path={[urls.explore.path]} onChange={(e) => {}}>
            <Explore />
          </Route>
          <Route exact path={[urls.platform.path]} onChange={(e) => {}}>
            <Platform />
          </Route>
          <Route exact path={[urls.soundmachine.path]}>
            <Soundmachine />
          </Route>
          <Route exact path={[urls.corporate.path]}>
            <CorporateStructure />
            {/* <GoToSection
            text={"Previous Section"}
            urlTitle={urls.explore.text}
            to={urls.explore.path}
          /> */}
          </Route>
          <Redirect to="/" />
        </Switch>
        {webGLContextInitialized && (
          <Suspense fallback={<LoadingBar />}>
            <Context3D>
              <Visualization3D
                visible={withVisualization}
                scene={"narrative"}
              />
            </Context3D>
          </Suspense>
        )}
      </div>
      <SVGAssets />
    </>
  );
}

export default App;
